import { numberFormatter } from 'core/helpers/formatters';

/**
 * The amount a member actually pays for a scheduled installment is `total` (we fall back to
 * `remainingMonthly` for schedules that predate the field). When a per-installment credit-card
 * processing fee applies, surface it inline so staff and members can see the fee is already included
 * rather than discovering it as a surprise at charge time (#35705). The backend only populates
 * `transactionFee` when the on-file method is a card on a fee-bearing farm policy, so a positive fee
 * is itself the card-gate here — no extra check is needed.
 */
export const scheduleInstallmentLabel = ({ remainingMonthly, total, transactionFee }) => {
  const amount = total ?? remainingMonthly;
  const fee = Number(transactionFee) || 0;
  if (fee > 0) {
    return `$${numberFormatter(amount, 2)} (incl. $${numberFormatter(fee, 2)} card fee)`;
  }
  return `$${numberFormatter(amount, 2)}`;
};
